import { useSettings } from "@/context/SettingsContext";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const settings = useSettings();
  const number = settings?.whatsapp || "919876543210";
  const msg = encodeURIComponent("Hi Happy Holidays Wale, I would like help planning a holiday.");
  const href = `https://wa.me/${number}?text=${msg}`;
  return (
    <a
      data-testid="whatsapp-float-button"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-whatsapp px-4 py-4 text-white shadow-[0_10px_30px_rgba(37,211,102,0.5)] transition-transform duration-300 hover:scale-110 md:bottom-8 md:right-8"
      style={{ backgroundColor: "#25D366" }}
    >
      <MessageCircle className="h-6 w-6" fill="white" />
      <span className="hidden font-semibold md:inline">WhatsApp Us</span>
    </a>
  );
}
